export default function ArchivedClaimsSearch() {
  return (
    <div style={styles.container}>
      <h2>Archived Claims Search</h2>
      <p style={styles.sub}>Search archived claim records.</p>
    </div>
  );
}
const styles = {
  container: {
    padding: "24px",
    background: "#f8fafc",
    minHeight: "100vh",
  },
  sub: {
    color: "#64748b",
    marginTop: "6px",
  },
};